export let windowWidth = window.innerWidth
export let windowHeight = window.innerHeight

export function refreshWindowSize() {
    windowWidth = window.innerWidth
    windowHeight = window.innerHeight
}

export const CINETIC_ABSORPTION = 0.5
export const BASIC_PUSH_FORCE = 7

export const TILE_SIZE = 100
export const PI = 3.14159265359


// WEBPACK FOOTER //
// ./src/config.js